import React, { useEffect, useState } from 'react';
import { LoadingIndicator } from '../../toolympus/components/primitives';
import { PublicPageHarness } from '../Common/PublicPageWrapper';
import { login, useUser } from '../../toolympus/userContext/UserContext';
import { useHistory } from 'react-router-dom';

export const LoginTokenContainer = () => {
  const history = useHistory();
  const user = useUser();

  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search)?.get("token");
    if(token) {
      setIsError(false);
      login(user, token);
      history.push("/");
    } else {
      setIsError(true);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PublicPageHarness>
      {isError
        ? "Something went wrong..."
        : <LoadingIndicator />}
  </PublicPageHarness>;
}